import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { breakpoints } from '../../utils/breakpoints';

import { InfoRounded } from '@material-ui/icons';

const HeroSection = styled.section`
  display: flex;
  justify-content: center;
  height: 20.875rem;
  position: relative;

  @media ${breakpoints.tablet} {
    height: 23.6875rem;
  }

  .info-icon {
    color: #ddaf65;
    font-size: 40px;
    margin-right: 15px;
    margin-top: 3px;
  }
`;

const UnauthorizedContent = styled.div`
  background-color: #ffefd5;
  border-left: 13px solid #ddaf65;
  border-radius: 6px;
  padding: 5px;
  z-index: 16;
  // position: absolute;
  bottom: 10px;
  margin: 0 10px;
  display: flex;
  align-items: center;
  @media ${breakpoints.tablet} {
    padding: 20px 20px 20px 15px;
  }
`;
const UnauthorizedTextDiv = styled.div``;
const UnauthorizedHeadText = styled.div`
  font-family: Open Sans;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.005em;
  text-align: left;
`;
const UnauthorizedContentText = styled.div`
  font-family: Open Sans;
  font-size: 15px;
  letter-spacing: 0.005em;
  text-align: left;
`;
const LinkToMessage = styled.a`
  font-family: 'Open Sans', sans-serif;
  color: #4f879d;

  &:hover {
    color: #4f879d;
  }
`;

export default function Hero() {
  const {
    meta: { title, id, is_authorizable },
    images: { background: backgroundImage },
  } = useSelector(state => state.programBrochure);

  const isAdminSignin = useSelector(state => state.profile.admin_sign_in);
  const freemium = useSelector(state => state.profile.freemium);
  const lead = useSelector(state => state.profile.lead);
  const programAlias = useSelector(state => state.profile.customAliases.alias_program || 'program');

  return (
    <>
      {/* <div className="bg" aria-hidden="true" /> */}
      {/* <img src={backgroundImage} alt="Program Banner Image" className="image" />
      <span tabIndex={0} className="title">{title}</span> */}
      {isAdminSignin &&
        (freemium || lead) &&
        (is_authorizable !== undefined && !is_authorizable) && (
          <UnauthorizedContent>
            <InfoRounded className="info-icon" />
            <UnauthorizedTextDiv>
              <UnauthorizedHeadText>
                Your {programAlias.toLowerCase()} is not set as Authorizable, partner organizations will not be able to
                find this {programAlias.toLowerCase()}.
              </UnauthorizedHeadText>
              <UnauthorizedContentText>
                Allow authorization by other institutions from{' '}
                <LinkToMessage href={`/client/programs/${id}/modify`}>Edit {programAlias} Brochure Modify Page</LinkToMessage>
              </UnauthorizedContentText>
            </UnauthorizedTextDiv>
          </UnauthorizedContent>
        )}
    </>
  );
}
